import React from 'react';

import { Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import { AppStore as StoreProps } from '../../interfaces/appStore';
import { makeMainGEvent, pushEvent } from '../../utils/analytics';

import styles from './AppStore.module.scss';

type AppStoreProps = {
  store: StoreProps;
};

export const AppStore: React.FC<AppStoreProps> = (props) => {
  const { store } = props;
  const cx = useStyles(styles);

  const handleClick = React.useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    const { store } = event.currentTarget.dataset;

    pushEvent(
      makeMainGEvent({
        eventCategory: 'Главная',
        eventAction: 'Переход к установке приложения',
        eventLabel: `Главная|${store}`,
      }),
    );
  }, []);

  return (
    <Typography.Link
      key={store.name}
      href={store.href}
      onClick={handleClick}
      target="_blank"
      rel="nofollow noopener"
      data-store={store.name}
      aria-label={store.name}
      className={cx('link')}
    >
      {store.icon}
    </Typography.Link>
  );
};
